import React, { useState } from 'react'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import { observer } from 'mobx-react'
import SelectCustom from '../../../../ContentBox/Global/Select/SelectCustom'

const AddEditDeferredDeal = () => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  const periods = [
    { id: 1, name: 30, label: 30 },
    { id: 2, name: 60, label: 60 },
    { id: 3, name: 90, label: 90 },
    { id: 4, name: 365, label: 365 },
  ]

  return (
    <FormField>
      <FormLabel>{'Выберите период'}:</FormLabel>
      <SelectCustom
        options={periods || []}
        valueID={modalValue.deferred_until || ''}
        placeholder={'Выберите период'}
        onChange={(e) => {
          changeValues(e.name, 'deferred_until')
        }}
        error={check('deferred_until')}
        optionValueKey='name'
      />
    </FormField>
  )
}

export default observer(AddEditDeferredDeal)
